import { useState, useEffect } from 'react';
import styles from './nav-header.module.css';
import logo from './images/logo.jpg';
import axios from 'axios';


const NavHeader = () => {
    const [isActive, setIsActive] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const [activeLink, setActiveLink] = useState('/home');
    const [totalUnread, setTotalUnread] = useState(0);
    const token = localStorage.getItem('token');

    const toggleNavbar = () => {
        setIsActive(!isActive);
    };

    const closeNavbar = () => {
        setIsActive(false);
    };

    // Handle scroll effect
    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.pageYOffset;
            setIsScrolled(scrollTop > 50);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Handle active link
    useEffect(() => {
        setActiveLink(window.location.pathname);
    }, []);

    const handleLinkClick = (href) => {
        setActiveLink(href);
        closeNavbar();
    };
    useEffect(() => {
            const fetchUnreadCount = async () => {
                try {
                    const response = await axios.get(
                        '/api/applicant/messages/unread-count',
                        { headers: { Authorization: `Bearer ${token}` } }
                    );
                    if (response.data.success) {
                        setTotalUnread(response.data.totalUnread);
                    }
                } catch (error) {
                    console.error('Error fetching unread count:', error);
                }
            };
    
            fetchUnreadCount();
        }, []);

    const navItems = [
        { href: '/home', label: 'Home' },
        { href: '/project-networks', label: 'Projects' },
        { href: '/social', label: 'Social' },
        { href: '/learn-teach', label: 'Learn/Teach' },
        { href: '/applied-interns', label: 'Applied' },
        { href: '/recruiter-messages', label: 'Recruiters' },
        { href: '/messages', label: 'Messages', badge:(totalUnread > 0 && totalUnread) }, // Optional notification badge        
        { href: '/profile', label: 'Profile' },
        // { href: '/notifications', label: 'Notifications' },
        { href: '/settings', label: 'Settings' },
        { href: '/logout', label: 'Logout' }
    ];

    return (
        <nav className={`${styles.navbar} ${isActive ? styles.navbarActive : ''} ${isScrolled ? styles.scrolled : ''}`}>
            <div onClick={() => window.location.href = '/'}className={styles.logoContainer}>
                <img title="UI" className={styles.logo} src={logo} alt="Logo" />
                <div className={styles.navbarLogo}>UNPAID INTERNSHIPS</div>
            </div>
            
            <ul className={styles.navbarLinks}>
                {navItems.map((item, index) => (
                    <li key={index}>
                            <a 
                            href={item.href}
                            className={activeLink === item.href ? styles.active : ''}
                            onClick={() => handleLinkClick(item.href)}
                        >
                            {item.label}
                            {item.badge && item.badge > 0 && (
                                <span className={styles.badge}>{item.badge}</span>
                            )}
                        </a>
                    </li>
                ))}
            </ul>
            
            <button 
                className={styles.navbarToggle} 
                onClick={toggleNavbar}
                aria-label="Toggle navigation menu"
                aria-expanded={isActive}
                                
            >
                <span className={styles.bar}>
                    {totalUnread > 0 &&
                    <span className={styles.bigBadge}>
                        {totalUnread}
                    </span>}
                </span>
                <span className={styles.bar}></span>
                <span className={styles.bar}></span>
            </button>
        </nav>
    );
};

export default NavHeader;